import styled from 'styled-components';

export const StyledButtonContainer = styled.div`
    display: flex;
`

export const StyledButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    color: white;
    font-size: 1.5rem;
    line-height: 2rem;
    background-color: #44A43F;
    border-radius: 1.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 12px;
    line-height: 1rem;
    border: none;
    min-width: 110px;
    width: fit-content;
    cursor: pointer;
`